import { gql } from '@apollo/client';

import { FileInfoFragment } from '@modules/shared/graphql';
import { TestAnswerFragment } from './test-answer';

export const TestQuestionSingleFragment = gql`
    fragment TestQuestionSingle on OLTestQuestion {
        id
        subjectId
        text
        photoIds
        answers {
            ...TestAnswer
        }
        photos {
            ...FileInfo
        }
    }
    ${TestAnswerFragment}
    ${FileInfoFragment}
`;
